import './verification.scss'
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import {Helmet} from "react-helmet";
import React from "react";

const Verification = () => {
  return (
    <>
    <main className='typora-export'>
      <Helmet>
        <meta property="title" content="Xerinola - Verification" />
        <meta property="title" lang="ca" content="Xerinola - Verificació" />
        <meta property="title" lang="en" content="Xerinola - Verification" />
        <meta property="title" lang="es" content="Xerinola - Verificación" />
        <meta property="og:title" content="Xerinola - Verification" />
        <meta property="og:title" lang="ca" content="Xerinola - Verificació" />
        <meta property="og:title" lang="en" content="Xerinola - Verification" />
        <meta property="og:title" lang="es" content="Xerinola - Verificación" />
        <meta property="og:url" content="https://xerinola.io/verification" />
      </Helmet>
      <Header section="Sobre nosotros"/>
      <div className="container">
        <div className="content">
          <p>
            ¡Hola! Mi nombre es Roger Serentill Gené soy dueño del negocio Roger Serentill Gené, donde ofrecemos un servicio de gestión de invitados de bodas y eventos.
          </p>
          <p>
            Deseo verificar mi cuenta de administrador comercial con número de identificación 3028382444138175.
            Anexo la información para complementar mi solicitud:
          </p>
          <p>
            Nombre: Roger Serentill Gené<br/>
            Identificación Fiscal: 47933451W<br/>
            Correo Electrónico: hello@rogerserentill.com<br/>
            Número telefónico: 647759691<br/>
            Dirección: Avda. de Lleida, 52, Benavent de Segrià, Lleida, 25132, ES<br/>
            Nombre del Negocio: Roger Serentill Gené<br/>
            ID del Administrador: 3028382444138175
          </p>
        </div>
      </div>
    </main>
    <Footer />
    </>
  )
}

export default Verification
